<template>
  <div class="row">
    <div class="col titre">
      <h2>Modifier Message utilisateur</h2>
    </div>
  </div>
  <AjouterFormMessage :message="message" @sauvegarder="sauvegarder"/>
</template>

<script>
import {mapGetters} from "vuex";
import AjouterFormMessage from '../../../components/pilotage/MessageUtilisateur/AjouterFormMessage.vue'
export default {
  components: {
    AjouterFormMessage
  },
  computed: {
    ...mapGetters({
      message: "pilotage/messageToUpdate",
    }),
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Modifier Message Utilisateur");
  },
  methods: {
    sauvegarder(message) {
      this.$store.dispatch('pilotage/modifierMessageAction', {message: message}).then(() => {
        this.$root.$refs.breadcrumbComp.rediriger();
      });
    }
  }
}
</script>
